<template>
    <form @submit.prevent="reset" class="mt-8">
        <input-group name="password" v-model="form.password" type="password" icon="lock-closed"
                     :label="$t('auth.password')" :form="form"
                     class="mt-4"/>
        <input-group name="password_confirmation" v-model="form.password_confirmation" type="password" icon="lock-closed"
                     :label="$t('auth.password_confirmation')" :form="form"
                     class="mt-4"/>

        <default-button type="submit" color="green" icon="lock-closed" :loading="form.processing"
                        class="mt-6" block>
            {{ $t('auth.login') }}
        </default-button>
    </form>
</template>

<script>
export default {
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                password_confirmation: '',
                token: '',
            }),
        };
    },

    created() {
        this.form.email = session.get('email');
        this.form.token = session.get('token');
    },

    methods: {
        reset() {
            this.form.post(this.route('password.update'), {
                onSuccess: () => this.$emit('change-mode', 'login'),
            });
        },
    },
};
</script>
